import * as React from 'react';

import * as s from './AddPostForm.css';

export interface IAddBlogPostFormParams {
  heading: React.ReactNode;
  titleField: React.ReactNode;
}

/**
 * Шаблон формы добавления/редактирования поста блога
 */
export const AddBlogPostForm = ({ heading, titleField }: IAddBlogPostFormParams) => {
  return (
    <div className={s['wrapper']}>
      <div className={s['heading']}>{heading}</div>

      <form className={s['form']}>
        <div className={s['field']}>{titleField}</div>
      </form>
    </div>
  );
};
